require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-the-masters-of-automotive.json") })
        }
      }, "path---news-the-masters-of-automotive");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-the-masters-of-automotive!./.cache/json/news-the-masters-of-automotive.json
// module id = 1438
// module chunks = 231608221292675